'use client';

import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Toast from '@alltrails/denali/components/Toast';
import useTrailCompleted from '@alltrails/lists/hooks/useTrailCompleted';
import type { TrailId } from '@alltrails/types/TrailId';
import styles from './CompletedToast.module.scss';

type CompletedToastProps = {
  trailId: TrailId;
};

const CompletedToast = ({ trailId }: CompletedToastProps) => {
  const { completed } = useTrailCompleted(trailId);
  const initialRender = useRef(true);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (completed == null) {
      return;
    }

    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    setIsOpen(true);
    const timeout = setTimeout(() => {
      setIsOpen(false);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [completed]);

  return (
    <Toast
      className={styles.completedToast}
      isOpen={isOpen}
      message={completed ? <FormattedMessage defaultMessage="Marked as completed" /> : <FormattedMessage defaultMessage="Removed from completed" />}
      position="alternative"
      type="neutral"
    />
  );
};

export default CompletedToast;
